import styled from '@emotion/styled'

export const SalesReportNavigationTabsWrapper = styled.div``
